import instance from '../../../api/axios'

export const removeFile = async (id: string): Promise<string> => {
  const response = await instance.delete(`/files/${id}`)

  return response.data
}

export default removeFile
